import { donationInfo } from '@data/siteData';
import { Card, CardContent, CardHeader, CardTitle } from '@components/ui/Card';
import { Heart, CheckCircle, Building2, History, Star, MapPin } from 'lucide-react';

export default function UnterstuetzenPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Unterstützen Sie die Sternwarte
          </h1>
          <p className="text-lg text-slate-400">
            Die Zukunft der Alten Sternwarte steht nun nicht mehr in den Sternen! Sie können uns
            helfen, das historische Gebäude weiterhin zu erhalten.
          </p>
        </div>

        {/* Donation Info */}
        <Card className="mb-8 border-green-800/30">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-green-600/10 rounded-lg flex items-center justify-center">
                <Heart className="text-green-400" size={24} />
              </div>
              <CardTitle>Spendenkonto</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-3 text-slate-300">
              <p>
                <span className="text-slate-500">Empfänger:</span>{' '}
                {donationInfo.recipient}
              </p>
              <p>
                <span className="text-slate-500">IBAN:</span>{' '}
                <span className="font-mono text-white">{donationInfo.iban}</span>
              </p>
              <p>
                <span className="text-slate-500">Bank:</span> {donationInfo.bank}
              </p>
              <p>
                <span className="text-slate-500">Verwendungszweck:</span>{' '}
                {donationInfo.reference}
              </p>
            </div>
            <div className="mt-6 p-4 bg-green-900/20 border border-green-800/50 rounded-lg">
              <p className="text-green-300 text-sm">{donationInfo.taxNote}</p>
            </div>
          </CardContent>
        </Card>

        {/* Historical Significance */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-white mb-6">Warum die Sternwarte wichtig ist</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Card>
              <CardContent className="flex items-start gap-4 py-4">
                <div className="w-10 h-10 bg-blue-600/10 rounded-lg flex items-center justify-center shrink-0">
                  <Building2 className="text-blue-400" size={20} />
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Historische Bedeutung</h3>
                  <p className="text-slate-400 text-sm">
                    Eines der ältesten Gebäude Mannheims und für Baden-Württemberg einzigartig
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="flex items-start gap-4 py-4">
                <div className="w-10 h-10 bg-purple-600/10 rounded-lg flex items-center justify-center shrink-0">
                  <History className="text-purple-400" size={20} />
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Forschungsgeschichte</h3>
                  <p className="text-slate-400 text-sm">
                    1775-1880 astronomische Forschung unter Christian Mayer
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="flex items-start gap-4 py-4">
                <div className="w-10 h-10 bg-amber-600/10 rounded-lg flex items-center justify-center shrink-0">
                  <Star className="text-amber-400" size={20} />
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Berühmte Besucher</h3>
                  <p className="text-slate-400 text-sm">
                    Mozart, Thomas Jefferson und viele mehr
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="flex items-start gap-4 py-4">
                <div className="w-10 h-10 bg-green-600/10 rounded-lg flex items-center justify-center shrink-0">
                  <MapPin className="text-green-400" size={20} />
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Stadtbild</h3>
                  <p className="text-slate-400 text-sm">
                    Unverzichtbarer Teil des Mannheimer Stadtbilds und des Barockensembles
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Other Ways to Help */}
        <Card>
          <CardHeader>
            <CardTitle>Weitere Möglichkeiten der Unterstützung</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-300">
                <CheckCircle className="text-green-500 mt-0.5 shrink-0" size={18} />
                <span>Werden Sie Mitglied im Verein Stadtbild Mannheim e.V.</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300">
                <CheckCircle className="text-green-500 mt-0.5 shrink-0" size={18} />
                <span>Unterstützen Sie uns ehrenamtlich bei Veranstaltungen</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300">
                <CheckCircle className="text-green-500 mt-0.5 shrink-0" size={18} />
                <span>Empfehlen Sie die Sternwarte in Ihrem Netzwerk weiter</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300">
                <CheckCircle className="text-green-500 mt-0.5 shrink-0" size={18} />
                <span>Besuchen Sie unsere Führungen und Veranstaltungen</span>
              </li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
